// app/assets/javascripts/utils/jobPoller.js
import { getMetaContent } from 'utils';

const retryStatuses = ['pending', 'started'];
const successStatuses = ['completed', 'newly_completed'];
const failedStatuses = ['failed'];

export const pollJob = (jobInfo, pollInterval = 3000) => (
  new Promise((resolve, reject) => {
    let timeOut = null;
    const token = getMetaContent('csrf-token');

    const recurse = () => {
      fetch(`/api/user_jobs/user_jobs/${jobInfo.user_job_id}`, {
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token },
        method: 'GET'
      })
        .then(response => response.json())
        .then(responseJson => {
          const jobType = jobInfo.job_type;
          const status = responseJson[jobType] && responseJson[jobType].status;

          if (successStatuses.includes(status)) {
            resolve(responseJson);
          } else if (retryStatuses.includes(status)) {
            timeOut = setTimeout(() => {
              recurse();
            }, pollInterval);
          } else if (failedStatuses.includes(status)) {
            reject(new Error(status));
          } else {
            reject(new Error(`Unknown status: ${status}`));
          }
        });
    };
    recurse();
  })
);
